module.exports = __webpack_public_path__ + "img/hill-view.462c0d14.png";